import { IHistoryProvider, Answers, HistoryProviderOptions, HistoryMetaData } from "./IProvider";
import { deleteChatHistoryApi, generateTitleApi, getChatHistoryApi, getChatHistoryListApi, postChatHistoryApi } from "../../api";

export class CosmosDBProvider implements IHistoryProvider {
    getProviderName = () => HistoryProviderOptions.CosmosDB;

    private continuationToken: string | undefined;
    private isItemEnd: boolean = false;
    private static titleCache: Map<string, string> = new Map();

    resetContinuationToken() {
        this.continuationToken = undefined;
        this.isItemEnd = false;
    }

    async getNextItems(count: number, idToken?: string): Promise<HistoryMetaData[]> {
        if (this.isItemEnd) {
            return [];
        }

        try {
            const response = await getChatHistoryListApi(count, this.continuationToken, idToken || "");
            this.continuationToken = response.continuation_token;
            if (!this.continuationToken) {
                this.isItemEnd = true;
            }
            return response.sessions.map(session => {
                if (session.title) {
                    CosmosDBProvider.titleCache.set(session.id, session.title);
                }
                return {
                    id: session.id,
                    title: session.title,
                    timestamp: session.timestamp
                };
            });
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    async addItem(id: string, answers: Answers, idToken?: string): Promise<void> {
        let title = CosmosDBProvider.titleCache.get(id);

        // Generate title only for the first message (when answers has only 1 pair)
        if (!title && answers.length === 1) {
            try {
                const response = await generateTitleApi({ question: answers[0][0].message, answer: answers[0][1].message.content }, idToken || "");

                if (!response.ok) {
                    throw new Error(`Failed to generate title: ${response.status} ${response.statusText}`);
                }

                const result = await response.json();
                title = result.title;
                if (result.title) {
                    CosmosDBProvider.titleCache.set(id, result.title);
                }
            } catch (e) {
                console.error("Error generating title:", e);
                // Fallback to first question as title
                const fallbackTitle = answers[0][0].message;
                title = fallbackTitle.length > 50 ? fallbackTitle.substring(0, 50) + "..." : fallbackTitle;
                CosmosDBProvider.titleCache.set(id, title);
            }
        }

        await postChatHistoryApi({ id, title, answers }, idToken || "");
        return;
    }

    async getItem(id: string, idToken?: string): Promise<Answers | null> {
        const response = await getChatHistoryApi(id, idToken || "");
        return response.answers || null;
    }

    async deleteItem(id: string, idToken?: string): Promise<void> {
        await deleteChatHistoryApi(id, idToken || "");
        return;
    }
}
